import React from 'react';
import MuiTypography, { TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

export type TypographyProps = MuiTypographyProps;

export const Typography = React.forwardRef<HTMLSpanElement, TypographyProps>((props, ref) => {
  const { sx, ...rest } = props;

  return (
    <MuiTypography
      ref={ref}
      {...rest}
      sx={{
        ...sx,
      }}
    />
  );
});

Typography.displayName = 'Typography';